/**
 * Router instance ref. Set by routes.jsx after createRouter().
 * Used by auth, stores, and components that need to navigate without importing @/routes.
 */
/** @type {{ current: import('@tanstack/react-router').Router | null }} */
export const routerRef = { current: null };
